import { Box, Typography } from '@mui/material';
import {
	HowToBuySvg,
	MyAccountSvg,
	MyOrderSvg,
	PaymentMethodsSvg,
	ReturnsSvg,
} from '@/components/content/HelpCenter/parts/Icons';
import { CardLink } from '@/components/content/HelpCenter/parts/CardLink';
import {
	HelpCenterDescriptionSx,
	HelpCenterGridSx,
	HelpCenterTitleSx,
} from '@/components/content/HelpCenter/styles/main';
import React, { useState } from 'react';
import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { DpContainer, DpContainerProps } from '@/components/blocks/DpContainer';

export const HelpCenter: React.FC<DpContainerProps> = (props) => {
	const [selectedId, setSelectedId] = useState('DPValeHelpCenterHowToBuy');

	const handleClick = (id: string) => {
		setSelectedId(id);
	};

	const links = [
		{
			id: 'DPValeHelpCenterHowToBuy',
			name: 'CÓMO COMPRAR',
			icon: <HowToBuySvg />,
		},
		{
			id: 'DPValeHelpCenterMyOrder',
			name: 'MI PEDIDO',
			icon: <MyOrderSvg />,
		},
		{
			id: 'DPValeHelpCenterRefunds',
			name: 'ENVÍO Y DEVOLUCIONES',
			icon: <ReturnsSvg />,
		},
		{
			id: 'DPValeHelpCenterPaymentMethods',
			name: 'FORMAS DE PAGO',
			icon: <PaymentMethodsSvg />,
		},
		{
			id: 'DPValeHelpCenterMyAccount',
			name: 'MI CUENTA',
			icon: <MyAccountSvg />,
		},
	];

	return (
		<DpContainer {...props}>
			<Typography component="h1" sx={HelpCenterTitleSx}>
				{'CENTRO DE AYUDA'}
			</Typography>
			<Typography component="h2" sx={HelpCenterDescriptionSx}>
				{'¿Con qué tema te podemos ayudar? Selecciona una categoría de las opciones aquí debajo.'}
			</Typography>
			<Box sx={HelpCenterGridSx}>
				{links.map(({ name, id, icon }) => (
					<CardLink
						key={name}
						name={name}
						isActive={id === selectedId}
						icon={icon}
						onClick={() => handleClick(id)}
					/>
				))}
			</Box>
			<ContentRecommendation
				id={selectedId}
				properties={{
					emsName: selectedId,
				}}
			/>
		</DpContainer>
	);
};
